import { GenericStatus, GenericStatusColorType } from '../../../shared/interfaces/generic-status';
import { ObjectConfigStatus } from '../interfaces/object';

export const OBJECT_CONFIG_STATUS_DATA_MAP: {
  [key in ObjectConfigStatus]: GenericStatus<ObjectConfigStatus>;
} = {
  [ObjectConfigStatus.DISABLED]: {
    value: ObjectConfigStatus.DISABLED,
    displayName: 'Disabled',
    icon: 'disable',
    colorType: GenericStatusColorType.DISABLED
  },
  [ObjectConfigStatus.INACTIVE]: {
    value: ObjectConfigStatus.INACTIVE,
    displayName: 'Skipped',
    icon: 'skip',
    colorType: GenericStatusColorType.DISABLED
  },
  [ObjectConfigStatus.ACTIVE]: {
    value: ObjectConfigStatus.ACTIVE,
    displayName: 'Active',
    icon: 'circle-tick',
    colorType: GenericStatusColorType.SUCCESS
  },
  [ObjectConfigStatus.INACCESSIBLE]: {
    value: ObjectConfigStatus.INACCESSIBLE,
    displayName: 'Inaccessible',
    icon: 'error-outline',
    colorType: GenericStatusColorType.WARNING
  },
  [ObjectConfigStatus.INCONSISTENT]: {
    value: ObjectConfigStatus.INCONSISTENT,
    displayName: 'Inconsistent',
    icon: 'error-outline',
    colorType: GenericStatusColorType.WARNING
  }
};
